import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import PermissionsGate from "@/Shared/PermissionsGate";
import {InertiaLink} from "@inertiajs/inertia-react";

const AddedCouponActionBtns = ({id, isLive}) => {
  return (
    <div className='flex'>
      {
        !isLive && (
        <PermissionsGate scopes={['public-coupon']}>
        <InertiaLink className={'mr-3'} id="tooltip" data-tip="Publish coupon" href={route('added.coupons.publishing', id)}>
          <FontAwesomeIcon
            color={'green'}
            size={'lg'}
            icon={solid('arrow-right-long')}/>
        </InertiaLink>
      </PermissionsGate>
        )}
      <PermissionsGate scopes={['crud-coupon']}>
        <InertiaLink data-tip="Remove coupon" href={route('added.coupons.delete', id)}>
          <FontAwesomeIcon
            color={'red'}
            size={'lg'}
            icon={solid('xmark')}/>
        </InertiaLink>
      </PermissionsGate>
    </div>
  );
};

export default AddedCouponActionBtns;
